import React, { useEffect, useState } from 'react'
import schoolLogo from '../../Assets/founder1.jpg'
import schoolLogo2 from '../../Assets/founder2.jpeg'
import { Select, Card, Button } from 'antd'
import '../../App.css'
import { useNavigate } from 'react-router-dom'
import Footer from '../CommonComponent/Footer'
import Header from '../CommonComponent/Header'

const { Option } = Select

const TermsCondition = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  // ------------------- Disable Back Button -------------------
  useEffect(() => {
    // Push a dummy state
    window.history.pushState(null, null, window.location.href)

    const handlePopState = () => {
      // Push forward again
      window.history.pushState(null, null, window.location.href)
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])
  // ===================================================================

  const [agree, setAgree] = useState(false)
  const navigate = useNavigate()

  const handleNext = () => {
    if (agree) {
      navigate('/student/reg-fee-form') // 👉 change path as per your project
    }
  }

  return (
    <div className="bg-gray-100 min-h-screen">
      <Header />

      <div className="row m-0 p-md-5">
        <div className="col-12 col-md-2"></div>

        <div className="col-12 col-md-8 pb-5">
          <header className="bg-blue-600 text-start py-3 px-3 rounded-lg shadow-md">
            <h3 className="font-bold"> Terms & Conditions </h3>
          </header>

          <Card className="w-full max-w-3xl shadow-lg rounded-xl border mb-3">
            <p>
              ॰ सुवर्ण महोत्सवी महामैत्र मेळा हा दोन दिवसीय शनिवार दिनांक 24
              जानेवारी व रविवार दिनांक 25 जानेवारी 2026 रोजी होणार आहे{' '}
            </p>
            
            <p>
              ॰ २० जानेवारी 2026 पूर्वी सवलतीच्या 300 रुपये प्रती विद्यार्थी
              इतक्या दरात रजिस्ट्रेशन करून आपले नाव लवकरात लवकर नोंद करावे ,
              म्हणजे कमिटीला नियोजन करणे सोपे होईल{' '}
            </p>
            <p>
              ॰ निवासी येणाऱ्याकरिता गरम पाणी, इंडियन, वेस्ट्रेन टॉयलेट्स,
              आवश्यकतेनुसार मेडिकल यांची व्यवस्था केलेली आहे{' '}
            </p>
            <p>
              ॰ दोन दिवसीय नोंद केलेल्या प्रती विद्यार्थीचे 3 भोजन, 2 नास्ता 2
              हाय टी चे पास त्याच्या AM कडे दिले जातील{' '}
            </p>
            <p>
              ॰ एक दिवसीय नोंद केलेल्या चे 1 भोजन 1 नाश्ता 1 हाय टी चे पास
              त्याच्या AM (ACTIVE MEMBERS) कडे दिले जातील{' '}
            </p>
            <p>
              ॰ सोबत येणाऱ्या गेस्ट करीता जादा पास उपलब्ध असतील ( भोजन 150/-
              नाश्ता 50/-)
            </p>
            {/* <p>
              ॰ रजिस्ट्रेशन केलेल्या विद्यार्थ्यांना एक आठवण म्हणून फोटो फ्रेम,
              आपल्या शाळेच्या ड्रेसमधील इमेज सह नोदणी चे AI जनरेटेड ID कार्ड ,
              बहुमुल्य अशी "सुवर्ण महोत्सवी स्मरणिका", पेन , डायरी व पुस्तक अशा
              स्वरूपात भेटवस्तू सेट मिळेल.
            </p> */}

            <p>
              <b>महत्वाची सूचना:</b>
            </p>
            {/* <p>॰ फ्रेश आय कार्ड फोटो उपलोड करणे अनिवार्य आहे.</p>
            <p>
              ॰ शालेय काळातील किंवा जेवढा जुना असेल तेवढा जुना फोटो ( AI चा वापर
              करून शाळे मधील फोटो करण्याकरिता जुना फोटो लागणार आहे .जेवढा जुना
              फोटो असेल तेवढी शाळेतील आपली इमेज चांगली दिसेल) उपलोड करणे
              महत्वाचे आहे.
            </p>
            <p>
              ॰ रजिस्ट्रेशन करताना उपलोड करावयाच्या आपल्या फोटोची साईज १ MB
              पेक्षा कमी असावी.
            </p> */}
            <p>॰ रजिस्ट्रेशन करणे अनिवार्य आहे.</p>
            <p>
              ॰ लवकर रजिस्ट्रेशन करावे त्यामुळे मॅनेजमेंट कमिटीला काम करणे सोपे
              होईल व ऐन वेळेला गैर सोय होणार नाही.{' '}
            </p>
           
            <p>
              ॰ सहकुटुंब येणार असाल तर तसे निवास कमिटीला कळवावे (फक्त
              मुलींच्याकरिता )
            </p>
            <p>
              ॰ आपल्या विद्यालयाचा सुवर्णमहोत्सवी महामैत्र मेळा दीर्घकाळ आठवणीत
              रहावा म्हणून कार्यक्रमाची मांडणी आपल्या मित्रांच्या गाठी भेटी,
              आठवणी, त्याच बरोबर सहभोजन, मनोरंजन, दर्जेदार प्रमुख पाहुणा व
              गुणवंत माजी विद्यार्थी पुरस्कार प्रा. साम महाबळेश्वरवाला व मॅडम
              एडना महाबळेश्वरवाला पुरस्कार अशा गोष्टी राहतील. तसेच बॅक टू
              सोसायटी या कृतज्ञतेच्या भावनेतून बॅक टू स्कूल या अंतर्गत सर्वजण
              रजिस्ट्रेशन फी सोडून स्वेच्छेने जादा देणगी मूल्य देवू शकता. आपले
              नाव किंवा आपल्या हयात नसलेल्या प्रिय व्यक्तीचे नाव चिरंतन जिवंत
              ठेवण्यासाठी स्मरणार्थ आजी विद्यार्थी यांना विविध बक्षीस जाहीर करुन
              विद्यालयाच्या प्रती कृतकृत्य होवू शकता.
            </p>
            <p> ॰ आपण सारे माजी विद्यालयीन विद्यार्थी दाखवू युवकांना भविष्याचे दर्शन</p>
            <p> धन्यवाद !</p>
            <p> आपले स्नेहांकित, <br /> <b>सुवर्ण महोत्सवी महामैत्र मेळा नियोजन कमिटी 2026</b> </p>

            {/* ===== Checkbox Section ===== */}
            <div className="mt-5 mb-4">
              <input
                type="checkbox"
                id="agree"
                checked={agree}
                onChange={(e) => setAgree(e.target.checked)}
                style={{ width: 18, height: 18, marginRight: 10 }}
              />
              <label htmlFor="agree" className="text-lg">
                I have read & agree to the Terms & Conditions
              </label>
            </div>

            {/* ===== NEXT Button ===== */}
            <Button
              type="primary"
              size="large"
              style={{ width: '200px' }}
              disabled={!agree}
              onClick={handleNext}
            >
              Next →
            </Button>
          </Card>
        </div>

        <div className="col-12 col-md-2"></div>
      </div>

      <Footer />
    </div>
  )
}

export default TermsCondition
